/**
 * AuditLog — logs unauthorized access attempts for debugging and security monitoring.
 */

export interface AuditEntry {
  timestamp: number
  operation: "read" | "write"
  path: string
  reason: string
}

export class AuditLog {
  private entries: AuditEntry[] = []
  private maxEntries: number

  constructor(maxEntries = 1000) {
    this.maxEntries = maxEntries
  }

  logUnauthorized(operation: "read" | "write", path: string, reason: string): void {
    if (this.entries.length >= this.maxEntries) {
      this.entries.shift()
    }
    this.entries.push({
      timestamp: Date.now(),
      operation,
      path,
      reason,
    })
  }

  getEntries(): AuditEntry[] {
    return [...this.entries]
  }

  clear(): void {
    this.entries = []
  }
}
